(function() {// Wave Color Matcher
// Removes wave-enabled class if next section doesn't have section-padding
  document.addEventListener('DOMContentLoaded', () => {
    const waveEnabledSections = document.querySelectorAll('.wave-enabled');
    
    waveEnabledSections.forEach((waveSection) => {
      // Find the parent section container
      const parentSection = waveSection.closest('.section');
      if (!parentSection) return;
      
      // Find the next section
      const nextSection = parentSection.nextElementSibling;
      if (!nextSection) return;
      
      // Check if next section has section-padding class
      const nextHasPadding = nextSection.querySelector('.section-padding');
      
      // If next section doesn't have section-padding, remove wave
      if (!nextHasPadding) {
        waveSection.style.marginBottom = "0";
        waveSection.classList.remove('wave-enabled');
      }
    });
  });
})();
